/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Clipboard_Copy_Successdescription1Inputs */

const en_clipboard_copy_successdescription1 = /** @type {(inputs: Clipboard_Copy_Successdescription1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has been copied to your clipboard`)
};

/**
* | output |
* | --- |
* | "{name} has been copied to your clipboard" |
*
* @param {Clipboard_Copy_Successdescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const clipboard_copy_successdescription1 = /** @type {((inputs: Clipboard_Copy_Successdescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clipboard_Copy_Successdescription1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_clipboard_copy_successdescription1(inputs)
});
export { clipboard_copy_successdescription1 as "clipboard_copy_successDescription" }